import React, { useEffect, useMemo, useState } from 'react'
import Facade from '@whitecobalt/tungsten/esm/components/Facade';
import Icon from '@whitecobalt/tungsten/esm/components/Icon';
import { useScreenTitle } from '@whitecobalt/tungsten/hooks/useScreenTitle'
import { useLazyQuery } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import ProductThumbnail from '../Prefabs/ProductThumbnail';
import ProductFilter, { StateProps } from '../Prefabs/ProductFilter';
import { SealProductPropType, SealProductsSearchQuery, ShopProductSealsQuery, ShopProductSealsQueryType } from '@services/query/EcommerceQueries';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { emptyArray } from '@whitecobalt/tungsten/esm/common/utils/assets';
import FileKeyLoader from '@whitecobalt/tungsten/esm/components/FileKeyLoader';
import useWindowDimensions from '@utils/getWindowDimensions';
import SelectDropdown from '@whitecobalt/tungsten/esm/components/Fields/SelectDropdown';
interface SealProductsProps {
	type: 'fire' | 'fire-smoke' | 'acoustic' | 'weather';
	menuDescription?: string;
	shopLinks: {
        label: string;
        value: string;
    }[]
    productTypeURL?: string;
	productCategoryURL?: string;
}

const SealProducts: React.FunctionComponent<SealProductsProps> = ({type, menuDescription, shopLinks, productTypeURL, productCategoryURL}) => {
    const isFire = type === 'fire'
    const isFireSmoke = type === 'fire-smoke'
    const isAcoustic = type === 'acoustic'
    const isWeather = type === 'weather'
	const { height, width } = useWindowDimensions();
	const title = isFire 
		? 'Fire Seals' 
            : isFireSmoke 
                ? 'Fire & Smoke Seals' 
                    : 'Acoustic Seals'

    useScreenTitle(`Halspan Store - ${title}`);
	
	const history = useHistory()

	const [filters, setFilters] = useState<Pick<StateProps, 'halspanVerified' >>({
		halspanVerified: null,
	})

    const [loadProducts, request] = useLazyQuery<{ search: { items: SealProductPropType[] }}>(SealProductsSearchQuery, {
		fetchPolicy: 'no-cache'
	})
	
    const sealProductsType = isFire ? [8] : isFireSmoke ? [8, 5] : isAcoustic ? [7] : isWeather ? [6] : [];
    
	const variables = {
		where: {
			ShopSealTypes:
			{ all: { ID: { in: sealProductsType } } },
			...(filters.halspanVerified !== null  && { HalspanVerified : {
				equals: filters?.halspanVerified 
			} }),
			ShowOnWebsite: {
				equals: true
			}
		}
	}

	useEffect(() => {
		loadProducts({
			variables
		})
	}, [type, filters])

    const data = useMemo(() => request.data?.search?.items.filter(item => {
		return sealProductsType.every(each => item.ShopSealTypeIDs.includes(each))
		}) || emptyArray
	, [request.data?.search?.items])

	useEffect(()=>{
		if(data?.length === 1 && !request?.loading){
			let masterSealProductID = data[0]?.ID;
			history.push(`/store/seal/master/${masterSealProductID}`)
		}
	})
	
	const fileKeys = useMemo(() => {
		return data.filter((each) => !!each.SealProductImages[0]?.ImageUrl).map((each) => {
			return each.SealProductImages[0]?.ImageUrl
		})
	}, [data])

	const multiFetchPayload = useMemo(() => ({
		"maxWidthInPX": 175,
		"maxHeightInPX": 175,
	}), [])
    
    return (
		<>
			<div className="row">
				<div className="col-md-3 wc-sidebar-menu wc-products-home-side-menu wc-search-products">
					<ProductFilter 
						shopLinks={shopLinks}
						productTypeName="Seals"
						productCategory={title}
						menuDescription={menuDescription}
                        // hasHalspanVerified
						onChange={(events) => {
							setFilters(prev => ({
								...prev,
								...events
							}))
						}}
						productTypeURL={productTypeURL}
						productCategoryURL={productCategoryURL}
						 />
				</div>
				<div className="col-md-9">
					<div className="row">
						<FileKeyLoader.MultiFetch
							fileKeys={fileKeys}
							payload={multiFetchPayload}
							cache
							cacheUniqueString="175px"
						>
							{data.length > 0 ? data.map((item) => {
								return (
									<div key={item.ID} className="col-sm-6 col-lg-4 col-xl-3">
										<ProductThumbnail 
											productName={item.Name} 
											fileKey={(item.DefaultSealProductImage?.Value?.ImageUrl || item.SealProductImages[0]?.ImageUrl)} 
											url={`/store/seal/master/${item.ID}`}
											/>
									</div>
								)
							}) : request.loading ? (
								new Array(8).fill(0).map((_: any, index) => (
									<div key={index} className="col-sm-6 col-lg-4 col-xl-3 wc-product-search-item">
										<div className="product-thumbnail">
											<h4><Facade title rows={0} padding={false} rowListStyle={{margin: 0}} /></h4>
											<Facade rows={1} padding={false} rowListStyle={{margin: 0}} rowStyle={{ borderRadius: 0, width: '100%', height: 150}} />
										</div>
									</div>
								))
							) : (
								<div className="d-flex justify-content-center w-100">
									<div className="text-center my-5">
										<Icon name="inbox" size={25}/>
										<h4 className="mt-2">No {title} to display</h4>
									</div>
								</div>
							)}
						</FileKeyLoader.MultiFetch>
					</div>
				</div>
			</div>   
		</>
    )
}

export default SealProducts